// src/routes/PrivateRoute.js
import React from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
import Loading from '../components/common/Loading';

const PrivateRoute = ({ minLevel = 1 }) => {
  const { user, loading, isAuthenticated, logout } = useAuth();
  const location = useLocation();

  if (loading) {
    return <Loading text="인증 확인 중..." />;
  }

  if (!isAuthenticated) {
    const loginPath = minLevel >= 9 ? '/super-admin/login' : '/admin/login';
    return <Navigate to={loginPath} state={{ from: location }} replace />;
  }

  if (user.level < minLevel) {
    return (
      <div style={{ padding: '2rem', textAlign: 'center' }}>
        <h2>권한이 부족합니다</h2>
        <p>이 페이지에 접근할 권한이 없습니다. 다른 계정으로 로그인하거나 관리자에게 권한을 요청하세요.</p>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'center', marginTop: 16 }}>
          {user.level >= 2 && <a href="/admin" className="btn btn-secondary">관리자 홈</a>}
          <button
            type="button"
            className="btn btn-primary"
            onClick={() => { if (logout) logout(); window.location.href = minLevel >= 9 ? '/super-admin/login' : '/admin/login'; }}
          >
            로그아웃
          </button>
        </div>
      </div>
    );
  }

  return <Outlet />;
};

export default PrivateRoute;
